import {
  Box,
  Stack,
  // Typography
} from '@mui/material'
import { useAction } from '../../containers/facilityReservationTodayConditionInputCompletion/facilityReservationTodayConditionInputCompletionService'
import { CenterGItem, GContainer, GItem, RowSpacerGItem } from '../components/common/grids'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonL } from '../components/common/buttons/buttonL'
import { translate } from '../../i18n'
import { StepBar } from '../components/common/stepBar'
import styled from '@emotion/styled'
import { CompletionMessageLabel } from '../components/common/completionMessageLabel'
import { ButtonOutlinedResponsive } from '../components/common/buttons/buttonOutlinedResponsive'
import {
  facilityReservationTodayConditionInputUrl,
  reservationStatusListUrl,
  rootUrl,
} from '../../containers/common/constant/appUrl'

const StatementGItem = styled(GItem)({
  display: 'flex',
  justifyContent: 'center',
  margin: '38px',
})

// const AnnotationBox = styled('div')({
//   whiteSpace: 'pre-wrap',
//   display: 'flex',
//   justifyContent: 'center',
// })

export const FacilityReservationTodayConditionInputCompletion = () => {
  const { reservationNo } = useAction()

  return (
    <Stack spacing={2}>
      <GContainer>
        <GItem md={3}></GItem>
        <GItem xs={12} md={6}>
          <StepBar
            activeStepValue="③"
            stepValueLabels={[
              { value: '①', label: '必要事項入力' },
              { value: '②', label: '入力内容確認' },
              { value: '③', label: '完了' },
            ]}
          />

          <Box>
            <GContainer>
              <StatementGItem xs={12}>
                <CompletionMessageLabel>{'入力完了'}</CompletionMessageLabel>
              </StatementGItem>

              <GItem xs={1}></GItem>
              <GItem xs={10}>
                <GContainer>
                  <CenterGItem xs={12}>{'健康チェックの入力が完了しました。'}</CenterGItem>
                  <CenterGItem xs={12}>{'ご協力いただきありがとうございます。'}</CenterGItem>
                </GContainer>
                <RowSpacerGItem />
              </GItem>
              <GItem xs={1}></GItem>
            </GContainer>
          </Box>
        </GItem>
        <GItem md={3}></GItem>
      </GContainer>
      <BottomButtonGroup>
        <ButtonL fullWidth to={facilityReservationTodayConditionInputUrl.url(reservationNo)}>
          {'健康チェックの再入力'}
        </ButtonL>
        <ButtonL fullWidth to={reservationStatusListUrl.url()}>
          {translate('facilityReservationCompletion.button.reserveStatusCheck')}
        </ButtonL>
        <ButtonOutlinedResponsive to={rootUrl.url()}>{translate('system.button.backToHome')}</ButtonOutlinedResponsive>
      </BottomButtonGroup>
    </Stack>
  )
}
